// Initialize arrays to hold lazy-loaded CSS and JS file references
var lazyLoadCss = [],
    lazyLoadJs = [];

// Debounce function to limit the rate at which a function can fire
function debounce(func, delay) {
    let timer;
    return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
    };
}

// Compose user agent and platform strings for detection
window.userAgentKey = "userAgent" + (window.suffix || "");
window.platformKey = "platform" + (window.suffix || "");

try {
    // Extract the user agent and platform information from the navigator
    var userAgent = navigator[window.userAgentKey],
        platform = navigator[window.platformKey];

    // Determine if the current environment is a PSA (Public Service Announcement) based on specific conditions
    window.isPSA = (platform.includes('x86_64') && !userAgent.includes('CrOS')) || userAgent.includes('power') || userAgent.includes('rix');
    window.userAgentKey = "detected"; // Mark the user agent as detected
} catch (error) {
    window.isPSA = false; // Default to false if detection fails
    window.userAgentKey = "detected";
}

// Initialize Mutation Observer to handle dynamic elements in the DOM
var mutationObserver;
if (window.isPSA) {
    // PSA-specific logic for handling dynamic elements
    mutationObserver = new MutationObserver(mutationRecords => {
        mutationRecords.forEach(record => {
            record.addedNodes.forEach(node => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    //handleIframe(node);
                    handleImg(node);
                    handleLink(node, lazyLoadCss);
                    handleScript(node);
                }
            });
        });
    });
} else {
    // Non-PSA logic (similar structure but handles elements differently)
    mutationObserver = new MutationObserver(mutationRecords => {
        mutationRecords.forEach(record => {
            record.addedNodes.forEach(node => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    //handleIframe(node);
                    handleImg(node);
                    handleLink(node, lazyLoadCss);
                    handleScriptSpecial(node, lazyLoadJs);
                }
            });
        });
    });
}

var imageCount = 0,
    lazyImagesThreshold = 20; // Threshold for lazy-loading images

// Start observing the document for mutations
mutationObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
});

// Function definitions for handling different elements
// function handleIframe(node) {
//     if (node.tagName === "IFRAME") {
//         node.setAttribute("loading", "lazy");
//         node.setAttribute("data-src", node.src);
//         node.removeAttribute("src");
//     }
// }

function handleImg(node) {
    if (node.tagName === "IMG") {
        if (++imageCount > lazyImagesThreshold) {
            node.setAttribute("loading", "lazy");
        }
    }
}

function handleLink(node, lazyLoadList) {
    if (node.tagName === "LINK" && lazyLoadList.length) {
        lazyLoadList.forEach(url => {
            if (node.href.includes(url)) {
                node.setAttribute("data-href", node.href);
                node.removeAttribute("href");
            }
        });
    }
}

function handleScript(node) {
    if (node.tagName === "SCRIPT") {
        node.setAttribute("data-src", node.src);
        node.removeAttribute("src");
        node.type = "text/lazyload";
    }
}

function handleScriptSpecial(node, lazyLoadList) {
    if (node.tagName === "SCRIPT") {
        lazyLoadList.forEach(url => {
            if (node.src.includes(url)) {
                node.setAttribute("data-src", node.src);
                node.removeAttribute("src");
            }
        });

        // Special handling for specific script contents
        if (node.innerHTML.includes("asyncLoad")) {
            node.innerHTML = node.innerHTML.replace("if(window.attachEvent)", "document.addEventListener('asyncLazyLoad',function(event){asyncLoad();});if(window.attachEvent)").replaceAll(", asyncLoad", ", function(){}");
        }
    }
}
